(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.mc-header').forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const button = header.querySelector('.mc-header__burger');
      const nav = header.querySelector('.mc-header__nav');
      if (!button || !nav) return;
      const setOpen = open => {
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          button.focus();
        }
      });
      nav.addEventListener('click', event => {
        if (event.target.closest('a')) setOpen(false);
      });
      header.addEventListener('focusout', event => {
        if (!header.contains(event.relatedTarget)) setOpen(false);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
